import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';
import { addToCompare, removeFromCompare } from './reducers/compare';
import type { RootState } from './store';

export const listenerMiddleware = createListenerMiddleware();

listenerMiddleware.startListening({
  matcher: isAnyOf(addToCompare, removeFromCompare),
  effect: (action, listenerApi) => {
    const state = listenerApi.getState() as RootState;
    const compareState = state.compare;

    localStorage.setItem(
      'compareProducts',
      JSON.stringify(compareState.productsPKList)
    );
  }
});
